






























































































import { defineComponent } from '@nuxtjs/composition-api'
import useI18n from '@/composables/use-i18n'
import useBreakpoint from '@/composables/use-breakpoint'
import useDefaultMeta from '@/composables/use-default-meta'

export default defineComponent({
  name: 'aboutUs',
  layout: 'about',
  head: {},
  setup () {
    const { match } = useBreakpoint()
    const isMobile = !match('lg')

    const i18n = useI18n()
    useDefaultMeta({
      title: String(i18n.t('SEO.about-us.title')),
      description: String(i18n.t('SEO.about-us.metaDescription')),
    })

    const hero = 'https://cdn.gogoout.com/web/about/us/hero.jpg'

    const safetyImg = 'https://cdn.gogoout.com/web/about/us/user.jpg'

    const joinUsImg = 'https://cdn.gogoout.com/web/about/us/joinUs.jpg'

    const achievement = [
      {
        title: '5,000,000',
        content: i18n.t('about.us.achievement.01'),
        icon: 'icon-user',
      },
      {
        title: '9,000+',
        content: i18n.t('about.us.achievement.02'),
        icon: 'icon-gps',
      },
      {
        title: '100,000+',
        content: i18n.t('about.us.achievement.03'),
        icon: 'icon-car',
      },
      {
        title: '150+',
        content: i18n.t('about.us.achievement.04'),
        icon: 'icon-car-time',
      },
    ]

    const whatWeCanDo = [
      {
        index: 1,
        title: i18n.t('about.us.whatWeCanDo.subSlogan.01'),
        content: i18n.t('about.us.whatWeCanDo.content.01'),
        img: 'https://cdn.gogoout.com/web/about/us/fast.jpg',
      },
      {
        index: 2,
        title: i18n.t('about.us.whatWeCanDo.subSlogan.02'),
        content: i18n.t('about.us.whatWeCanDo.content.02'),
        img: 'https://cdn.gogoout.com/web/about/us/smart.jpg',
      },
      {
        index: 3,
        title: i18n.t('about.us.whatWeCanDo.subSlogan.03'),
        content: i18n.t('about.us.whatWeCanDo.content.03'),
        img: 'https://cdn.gogoout.com/web/about/us/simple.jpg',
      },
    ]

    return {
      isMobile,

      hero,
      safetyImg,
      joinUsImg,

      achievement,
      whatWeCanDo,
    }
  },
})
